import i18n from 'i18next'
import ICU from 'i18next-icu'
import { initReactI18next } from 'react-i18next'
import { withTolgee, Tolgee, I18nextPlugin, DevTools, BackendFetch } from '@tolgee/i18next'
import { AppLang, AppLangs } from '@e3dc-react/shell/State/App/AppModel'

import countryTranslations from 'i18n-iso-countries'
import de from 'i18n-iso-countries/langs/de.json'
import en from 'i18n-iso-countries/langs/en.json'
import nl from 'i18n-iso-countries/langs/nl.json'
import fr from 'i18n-iso-countries/langs/fr.json'
import it from 'i18n-iso-countries/langs/it.json'
import pl from 'i18n-iso-countries/langs/pl.json'
import pt from 'i18n-iso-countries/langs/pt.json'
import es from 'i18n-iso-countries/langs/es.json'
import sv from 'i18n-iso-countries/langs/sv.json'
import el from 'i18n-iso-countries/langs/el.json'
import { isFlowTheme } from 'src/Libs/utils'

// Support german, english & dutch languages.
countryTranslations.registerLocale(de)
countryTranslations.registerLocale(nl)
countryTranslations.registerLocale(en)
if (isFlowTheme) {
  countryTranslations.registerLocale(fr)
  countryTranslations.registerLocale(it)
  countryTranslations.registerLocale(pl)
  countryTranslations.registerLocale(pt)
  countryTranslations.registerLocale(es)
  countryTranslations.registerLocale(sv)
  countryTranslations.registerLocale(el)
}

const isTestEnv = process.env.REACT_APP_TEST_ENV === 'true'
const isProduction = process.env.REACT_APP_ENVIROMENT === 'production'
const isShowKeysMode = !isProduction && new URLSearchParams(window.location.search).has('showTranslationKeys')
const SUPPORTED_LANGUAGES = Object.values(AppLangs)
const FALLBACK_LANGUAGES: AppLang[] = ['en', 'de']

const getInitialLanguage = (): string => {
  const getBrowserLanguage = (): string => {
    if (!navigator.language) {
      return AppLangs.German
    }

    const browserLang = navigator.language.split('-')[0].toLowerCase() as AppLang
    if (SUPPORTED_LANGUAGES.includes(browserLang)) {
      return browserLang
    }

    return AppLangs.German
  }

  const getPersistedLanguage = (): string | null => {
    return localStorage.getItem('appLanguage')
  }

  return getPersistedLanguage() ?? getBrowserLanguage()
}

const tolgee = Tolgee()
  .use(DevTools())
  .use(I18nextPlugin())
  .use(BackendFetch({ prefix: process.env.REACT_APP_TOLGEE_CONTENT_DELIVERY_LINK }))
  .init({
    apiUrl: process.env.REACT_APP_TOLGEE_API_URL,
    apiKey: process.env.REACT_APP_TOLGEE_API_KEY,
    language: isShowKeysMode ? 'cimode' : getInitialLanguage(),
    availableNs: ['translation'],
    defaultNs: 'translation',
    tagNewKeys: ['draft'],
    fallbackLanguage: FALLBACK_LANGUAGES,
  })

withTolgee(i18n, tolgee)
  .use(ICU)
  .use(initReactI18next)
  .init({
    lng: isShowKeysMode ? 'cimode' : getInitialLanguage(),
    fallbackLng: FALLBACK_LANGUAGES,
    supportedLngs: SUPPORTED_LANGUAGES,
    ns: ['translation'],
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false,
    },
    react: {
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'b', 'u', 'p'],
      useSuspense: !isTestEnv,
    },
  })

export { default } from 'i18next'
